// extracted by mini-css-extract-plugin
module.exports = {"border-gray":"#ddd","searchNoResult":"EmptyView-module__searchNoResult___3D8Kv"};